import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Popover,
  Row,
  Tag,
  Tooltip,
  Checkbox, Upload
} from "antd";

import PB, {SimplePB} from "@/libs/simplePB";

import Icon from "@/components/common/common.icon";
import ViewManager from "@/components/common/common.viewManager";

import style from "@/style/common/view/common.view.info.setInfoModal.less";
import { IconTypes } from "@/constants/common";
// 创建图谱时，选择模板数据
import createViewTemplate from "@/assets/view-template/create-view-template";
import intl from 'react-intl-universal';

class createInfoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      desc: "",
      status: "idle",
      tags: [],
      uploading: false,
      comment: '',
      fileList: [],
    };
  }

  mounted = false;

  onUploadSuccess = () => {
      let me = this;
  
      if (me.mounted) {
        me.setState({
          uploading: false,
          fileList: [],
          comment: '',
        }, () => {
          me.props.onClose(true);
        });
      }
      // 显示进度条showPageLoading消失后显示message
      setTimeout(() => {
        message.success('上传信息成功');
      }, 700);
    };
  
    onUploadFailed = () => {
      let me = this;
  
      me.setState({uploading: false});
      message.error('上传信息失败，请重试');
    };
  
    doUpload = () => {
      let me = this;
      me.setState({
        uploading: true,
      }, () => {
        (me.props.doUpload || me.props.networkRef.addFiles)(me.props.nodeId, me.state.comment, me.state.fileList)
          .then(() => me.onUploadSuccess())
          .catch(() => me.onUploadFailed())
      });
    };
  
    onPastingImage = e => {
      let me = this;
      if (!me.props.visible) return;
      if (e.clipboardData && e.clipboardData.items) {
        // 从剪贴板中获取items
        let items = e.clipboardData.items;
        // 循环items获取剪贴板中的图片
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf('image') !== -1) {
            // 获取图片的文件信息
            let blob = items[i].getAsFile();
            let nowTime = new Date();
            // 配合输入框文字，"可粘贴截屏"好像不太顺，改为截图
            let fileName = '截图' + moment().format("YYYY-MM-DD HH:mm:ss");
            let file = new window.File([blob], fileName + '.png', {type: blob.type});
            file['uid'] = 'rc-upload-' + nowTime.getTime();
            me.setState({
              fileList: [...me.state.fileList, file],
            });
          }
        }
        e.preventDefault();
      }
    };

  addTagInputRef = undefined; // 标签输入框

  componentDidMount() {
    this.mounted = true;
    let me = this;
    // 聚焦添加描述文本框时，使用粘贴功能，提取剪贴板中图片作为附件
    window.addEventListener('paste', me.onPastingImage);
  }

  componentWillUnmount() {
    this.mounted = false;
    window.removeEventListener('paste', this.onPastingImage);
  }

  readFile = (file) => {
    let me = this;
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const jsonData = JSON.parse(e.target.result);
        console.error(jsonData);
        let mapData = {};
        if(jsonData.data && jsonData.status == 200){
          mapData = jsonData.data;
        }else{
          mapData = jsonData;
        }
        
        me.onJsonFileSave(mapData);
        /*
        if (validateJson(jsonData)) {
          console.log('Valid JSON:', jsonData);
          // 处理合法的JSON数据
        } else {
          console.error('Invalid JSON structure');
        }*/
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    };
    reader.onerror = (error) => {
      console.error('Error reading file:', error);
    };
    reader.readAsText(file); // 读取文件内容为文本
  };

  formatEdges = (mapData) => {
    let edges = [];
    mapData.edges.forEach((edge) => {
      let from = edge.from;
      let to = edge.to;
      mapData.nodes.forEach((node, index) => {
        if (node.id === from) {
          edge.fromIndex = index;
        }
        if (node.id === to) {
          edge.toIndex = index;
        }
      })
      edges.push(edge)
    });
    return edges;
  }

  onJsonFileSave = (mapData) => {
    let me = this;
    const { callback } = me.props;
    const currentUserId = localStorage.getItem("userId");
    
    me.setState(
      {
        status: "processing",
      },
      () => {
        const view_info = mapData.view||mapData.viewInfo;
        let edges = me.formatEdges(mapData);
        const newInfo = {
          name:view_info.name,
          desc:view_info.desc|| view_info.description,
          channel:view_info.channel || 0,
          tags:Array.isArray(view_info.tags)?view_info.tags.join(' '):view_info.tags,
          free: 0,
          initialRelation: {
            nodes: mapData.nodes,
            edges: edges,
          },
        };

        ViewManager.addView(newInfo, currentUserId)
          .then((res) => {
            me.setState({
              status: "success",
            });
            me.onClose();
            message.success("图谱创建成功");
            callback &&
              callback({ action: "create", success: true, viewInfo: res });
          })
          .catch((e) => {
            me.setState({
              status: "fail",
            });
            if(e.code==190001){
              //message.error(e.msg, 1).then(() => {
              //  PB.emit('account', 'user_upgrade.show_modal', {'up_by':'creat_map'});
              //});
          
              Modal.error({
                title: '超过限制',
                content: (
                  <span>{e.msg}</span>
                ),
                okText: '升级会员',
                cancelText: '取消',
                onOk: () => {
                  PB.emit('account', 'user_upgrade.show_modal', {'up_by':'creat_map'});
                },
                mask: true,
                maskClosable: false,
                okCancel: true,
              });
            }else{
              message.error("网络不稳定，请尝试重新保存。", 3);
              callback && callback({ action: "create", success: false });
            }
          });
      }
    );
  };

  onSave = () => {
    let me = this;
    me.readFile(me.state.fileList[0]);
    return;
  };

  onClose = () => {
    const me = this;
    me.props.onClose();
  };

  render() {
    let me = this;
    const {
      form,
      visible = {},
      params: { channel = 0 },
    } = me.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      // labelCol: {span: 24},
      // wrapperCol: {span: 24},
    };
    return (
      <Modal
        title={
          <div>
            <Icon name="edit" style={{ color: "#a5a5a5", marginRight: 10 }} />
            JSON导入图谱
          </div>
        }
        visible={visible}
        okText={"确定"}
        cancelText={"取消"}
        centered={true}
        destroyOnClose={true}
        maskClosable={false}
        width={550}
        onOk={() => me.onSave()}
        okButtonProps={{
          loading: this.state.status === "processing",
          disabled: (this.state.status === "processing" && !me.state.comment && me.state.fileList.length <= 0),
        }}
        wrapClassName={"custom-modal-confirm"}
        onCancel={() => me.setState({fileList: [], comment: ''}, () => me.onClose())}
      >
        <Upload.Dragger
          name='file'
          className={style['file-upload-list']}
          fileList={me.state.fileList}
          multiple={false}
          accept=".json"
          onRemove={(file) => {
            me.setState(({fileList}) => {
              const index = fileList.indexOf(file);
              const newFileList = fileList.slice();
              newFileList.splice(index, 1);
              return {
                fileList: newFileList,
              }
            })
          }}
          beforeUpload={(file) => {
            if (file.size > 50 * 1024 * 1024) {
              message.error("JSON文件不要超过50MB");
              return false
            }
            if (file.type !== 'application/json') {
              message.error("文件类型必须是JSON文件");
              return false
            }
            if (this.state.fileList.length > 0) {
              message.info(`不支持批量上传，文件 ${this.state.fileList[0].name} 已被替换`);
            }
            me.setState(() => ({
              fileList: [file],
            }));
            return false;
          }}
        >
          <p className="ant-upload-drag-icon">
            <Icon name="inbox"/>
          </p>
          <p className="ant-upload-text">
            点击选取上传JSON文件 或 拖拽JSON文件到这里<br />
            也可直接 Ctrl+V 粘贴
          </p>
        </Upload.Dragger>
      </Modal>
    );
  }
}

const WrappedCreateInfoModal = Form.create()(createInfoModal);

WrappedCreateInfoModal.defaultProps = {
  bus: PB,
  visible: false,
  callback: () => {},
  params: {
    channel: 0,
  },
};

WrappedCreateInfoModal.propTypes = {
  bus: PropTypes.instanceOf(SimplePB),
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  callback: PropTypes.func,
  params: PropTypes.object, // 额外的配置参数。eg: channel专题频道
};

export default WrappedCreateInfoModal;
